import { createBrowserRouter } from 'react-router-dom';

import App from './App';
import Home from './Home.jsx';
import RequireAuth from './RequireAuth';
import Dashboard from './Dashboard';
import CalendarView from './CalendarView.jsx';
import LoginPage from './endpoints/LoginPage.jsx';
import ForgotPassword from './endpoints/ForgotPassword.jsx';
import Welcome from './endpoints/Welcome.jsx';
import ResetPassword from './endpoints/ResetPassword.jsx';
import NotFound from './endpoints/NotFound.jsx';
import Forbidden from './endpoints/Forbidden.jsx';
// import PracticeManagement from './endpoints/PracticeManagement';
import Logs from './endpoints/Logs.jsx';
import PrivacyPolicy from './endpoints/PrivacyPolicy.jsx';
//USERS Endpoints
// import Users from './endpoints/Users.jsx';
// import RegisterUser from './endpoints/RegisterUser.jsx';
//CLINICS Endpoints
import Clinics from './endpoints/Clinics.jsx';
import ClinicOverview from './endpoints/ClinicOverview.jsx';
//LAYOUTS
import PublicLayout from './layouts/PublicLayout.jsx';
import PrivateLayout from './layouts/PrivateLayout.jsx';

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <NotFound />,
        children: [
            {
                // Any role permissed 
                element: <PublicLayout />,
                children: [
                    { index: true, element: <Home />},
                    { path: '/login', element: <LoginPage />},
                    { path: '/welcome', element: <Welcome />},
                    { path: '/forgot-password', element: <ForgotPassword />},
                    { path: '/reset-password', element: <ResetPassword />},
                    { path: '/privacy-policy', element: <PrivacyPolicy />},
                    { path: '/403', element: <Forbidden /> },
                ],
            },
            {
                element: 
                ( <RequireAuth allowedRoles={["user", "admin", "super_admin"]}>
                    <PrivateLayout />
                </RequireAuth>
                ),
                children: [
                    { path: '/dashboard', element: <Dashboard /> },
                    { path: '/calendar', element: <CalendarView />},
                ]
            },
            // Super admin and admin only
            {
                element: 
                ( <RequireAuth allowedRoles={["admin", "super_admin"]}>
                    <PrivateLayout />
                </RequireAuth>
                ),
                children: [
                    // { path: '/practice', element: <PracticeManagement /> },
                    { path: '/logs', element: <Logs /> },
                    // { path: '/practice/users', element: <Users /> },
                    // { path: '/practice/users/register-user', element: <RegisterUser /> },
                    { path: '/practice/clinics/:clinicId', element: <ClinicOverview/> },
                ],
            },
            // Super admin only
            {
                element: 
                ( <RequireAuth allowedRoles={["super_admin"]}>
                    <PrivateLayout />
                </RequireAuth>
                ),
                children: [
                    { path: '/practice/clinics', element: <Clinics /> },
                    // { path: '/practice/clinics/:clinicId', element: <ClinicOverview/> },
                ],
            },
        ],
    },
]);

export default router;